
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'


// andere libs
// import faArrowAltSquareLeft from '@fortawesome/fontawesome-pro-solid/faArrowAltSquareLeft'
// import faArrowAltSquareLeft from '@fortawesome/fontawesome-pro-regular/faArrowAltSquareLeft'
// import faArrowAltSquareLeft from '@fortawesome/fontawesome-pro-light/faArrowAltSquareLeft'


// https://github.com/FortAwesome/vue-fontawesome  uitleg
  const FAMixin = { 
    components: {
      FontAwesomeIcon, 
      FontAwesomeLayers,
      FontAwesomeLayersText
    }
  }

  export { FAMixin }

